/* @flow */

import * as React from 'react';

import {ActionMenu} from '../action-menu';
import {IconOnlyButton} from '../button/icon-only-button/icon-only-button';
import {Card} from '../card';
import {colors} from '../colors';
import {type SelectMenuOption} from '../select-menu';

import './toolbar.module.css';

export type ToolbarOption =
    | {|
          id: string,
          icon: React.ComponentType<*>,
          onClick: () => any,
          tooltipText: string,
          isDisabled?: boolean,
          getRef?: (?HTMLElement) => void,
          domId?: string,
      |}
    | {|
          // For cases where option is more complex than an icon
          component: React.Node,
          id: string,
      |};

export type ActionMenuOptions = {|
    options: SelectMenuOption[],
    getRef?: (?HTMLElement) => void,
|};

export type Props = {|
    options: ToolbarOption[],
    actionMenuOptions?: ActionMenuOptions,
|};

/**
 * This component is designed around the new style of icons which have square viewboxes
 * and where the icon doesn't visibly reach the edge of the viewbox.
 */
export function Toolbar(props: Props) {
    return (
        <Card
            hasBorder={true}
            fitContent={true}
            borderColor={colors.buttonSecondaryDk}
            hasShadow={true}
        >
            <div
                className='flex py-4 px-6 align-center gap-8'
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                }}
            >
                {props.options.length > 0 &&
                    props.options.map((option) => {
                        if (option.icon) {
                            return (
                                <IconOnlyButton
                                    id={option.domId}
                                    key={option.id}
                                    icon={option.icon}
                                    onClick={() => option.onClick()}
                                    tooltipText={option.tooltipText}
                                    isDisabled={option.isDisabled}
                                    getButtonRef={option.getRef}
                                />
                            );
                        }

                        return (
                            option.component && (
                                <React.Fragment key={option.id}>{option.component}</React.Fragment>
                            )
                        );
                    })}
                {props.actionMenuOptions && (
                    <div styleName='action-menu-container'>
                        <ActionMenu
                            size='tiny'
                            hasHoverBackground={true}
                            hasDarkHoverBackground={true}
                            options={props.actionMenuOptions.options}
                            getRef={props.actionMenuOptions.getRef}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
}
